import { createContext } from 'react';

type TabContextInterface = {
  idPrefix: string;
  selectedTab?: number;
  setSelectedTab: (tab: number) => void;
  focusedTab?: number;
  setFocusedTab: (tab: number) => void;
};

const TabContext = createContext<TabContextInterface>({
  idPrefix: 'tabs',
  setSelectedTab: () => {},
  setFocusedTab: () => {},
});

export { TabContext };
